import { render, staticRenderFns } from "./v-list.vue?vue&type=template&id=f9a54fd6"
import script from "./v-list.vue?vue&type=script&lang=js"
export * from "./v-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\GitWorkplace\\物联网\\tenda_iot_system\\node_modules\\_vue-hot-reload-api@2.3.4@vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f9a54fd6')) {
      api.createRecord('f9a54fd6', component.options)
    } else {
      api.reload('f9a54fd6', component.options)
    }
    module.hot.accept("./v-list.vue?vue&type=template&id=f9a54fd6", function () {
      api.rerender('f9a54fd6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/plugins/components/list/v-list.vue"
export default component.exports